import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { SalesService } from 'src/app/services/api/sales.service';
import { NotificationService } from 'src/shared/notification.service';

@Component({
  selector: 'app-edit-observacion',
  templateUrl: './edit-observacion.component.html',
  styleUrls: ['./edit-observacion.component.scss'],
})
export class EditObservacionComponent implements OnInit, OnDestroy {
  unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>();

  accion: string = 'añadir';
  loading: boolean = false;
  success: boolean = false;
  form: FormGroup;
  @Output() changeValueProps: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<EditObservacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private readonly fb: FormBuilder,
    private readonly salesService: SalesService,
    private readonly notificationService: NotificationService,
  ) {
    this.accion = this.data.accion ?? this.accion;
    this.form = this.fb.group({
      obs: new FormControl(
        data?.data?.observacionAYB || null,
        Validators.required,
      ),
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribeOnDestroy$.next(true);
    this.OnClose();
  }

  close() {
    this.dialogRef.close();
  }

  applyFilterSelect() {}

  async save() {
    this.loading = true;
    const observacionAYB = this.form.value.obs;
    this.salesService
      .updateServiceItinerary({
        id: this.data.data.id,
        observacionAYB,
      })
      .pipe(takeUntil(this.unsubscribeOnDestroy$))
      .subscribe({
        next: (res) => {
          this.success = true;
          this.loading = false;
          this.notificationService.showSuccessAlert(
            'Se actualizó el servicio exitosamente.',
          );
          this.OnClose();
        },
        error: (err: any) => {
          this.loading = false;
          this.notificationService.notifyError(err.message);
        },
      });
  }

  OnClose() {
    this.dialogRef.close({
      success: this.success,
      observacionAYB: this.form.value.obs,
    });
  }
  onCancel() {
    this.OnClose();
  }
}
